import script from "./goRinSyo0007.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0007.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0007.vue?vue&type=style&index=0&id=4e5e522a&lang=scss"

const __exports__ = script;

export default __exports__